import { CONSIGNMENT_CONFIG_EDIT_PERMISSION } from "@/features/consignment-settlement/components/ConsignmentConfigList";
import { ConsignmentConfigCreatePage } from "@/features/consignment-settlement/pages/ConsignmentConfigCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-config/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: [CONSIGNMENT_CONFIG_EDIT_PERMISSION],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentConfigCreatePage,
});
